import { Capacitor } from '@capacitor/core';
import { ExternalReturnValue } from 'src/app/@core/types';
import { StatusBar, Style } from '@capacitor/status-bar';

// Light = dark text on iOS
export function SetStatusBar(style: 'Light' | 'Dark' = 'Light', callback: string = 'ionViewWillEnter'): ClassDecorator {
  return (c: ExternalReturnValue): void => {
    const ionViewDidEnter = c.prototype[callback];

    // eslint-disable-next-line func-names
    c.prototype[callback] = async function (...args: ExternalReturnValue[]): Promise<void> {
      // eslint-disable-next-line no-unused-expressions,@typescript-eslint/no-unused-expressions
      ionViewDidEnter && ionViewDidEnter.apply(this, args);

      if (!Capacitor.isNativePlatform()) {
        return Promise.resolve();
      }

      if (Capacitor.getPlatform() === 'android') {
        await StatusBar.setStyle({
          style: Style.Dark,
        });
        await StatusBar.setBackgroundColor({
          color: '#000000',
        });
      } else {
        // TODO: find a better approach to set status bar based on current theme
        const isDarkTheme = document.documentElement.classList.contains('dark');

        await StatusBar.setStyle({
          style: isDarkTheme
            ? Style.Dark
            : Style[style],
        });
      }

      return Promise.resolve();
    };
  };
}
